import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getProfile, updateProfile, changePassword } from '@/api/settingsApi';
import type { UpdateProfileRequest, ChangePasswordRequest } from '@/types/settings';

export function useProfile() {
  return useQuery({
    queryKey: ['settings', 'profile'],
    queryFn: getProfile,
  });
}

export function useUpdateProfile() {
  const acqQueryClient = useQueryClient();
  return useMutation({
    mutationFn: (acqData: UpdateProfileRequest) => updateProfile(acqData),
    onSuccess: () => {
      acqQueryClient.invalidateQueries({ queryKey: ['settings', 'profile'] });
    },
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (acqData: ChangePasswordRequest) => changePassword(acqData),
  });
}
